import urlBase from 'EstruturaAntiga/assets/urlsBase';
import BaseService from './BaseService';

class PortalClienteDBService extends BaseService {
  constructor() {
    super(urlBase.urlBase);
  }
}

export default PortalClienteDBService;